/* Foneso PDP 车型适配查询条(座套类详情页自动挂载) — 2026-08-28 按惠婷规格重制 */
(function () {
  if (window.fonesoThemeFitLoaded) return;
  window.fonesoThemeFitLoaded = true;
  window.fonesoFitLoaded = true;
  var path = location.pathname || "";
  if (!/^\/products\//.test(path)) return;
  var handleMatch = path.match(/^\/products\/([^\/?#]+)/);
  if (!handleMatch) return;
  fetch("/products/" + handleMatch[1] + ".js").then(function (r) {
    if (!r.ok) throw new Error("product request returned HTTP " + r.status);
    return r.json();
  }).then(function (prod) {
    var tags = prod.tags || [];
    if (tags.indexOf("Universal Fit") === -1) return;
    mountFitBar();
  }).catch(function (error) {
    console.error("[Foneso Fit] Failed to load product data:", error);
  });

  function mountFitBar() {
    var h1txt = (document.querySelector("h1") || {}).textContent || "";
    if (/custom-fit|custom_fit/.test(path) || /^\s*For\s+/i.test(h1txt) || /custom fit/i.test(h1txt)) return;
    var base = "https://kenaimini.com/fchat/";
    var box = document.getElementById("foneso-fit-bar");

    function disableDependentSelects() {
      if (!box) return;
      var failedMake = box.querySelector("#ffb-make");
      var failedModel = box.querySelector("#ffb-model");
      if (failedMake) failedMake.disabled = true;
      if (failedModel) failedModel.disabled = true;
    }

    disableDependentSelects();
    fetch(base + "vehicles.json").then(function (r) {
      if (!r.ok) throw new Error("vehicle request returned HTTP " + r.status);
      return r.json();
    }).then(function (data) {
      var V = data.vehicles || [], VD = data.verdicts || {};
      if (!Array.isArray(V) || !V.length) throw new Error("vehicle dataset is empty");
      if (!box) {
        var form = document.querySelector('form[action*="/cart/add"]');
        if (!form || !form.parentNode) return;
        box = document.createElement("div");
        box.id = "foneso-fit-bar";
        box.style.cssText = "background:#fff;border:1px solid #E5E7EB;border-radius:9px;padding:13px 14px;margin:12px 0;box-sizing:border-box;";
        box.innerHTML =
          '<div style="font-size:14.5px;font-weight:700;color:#111827;margin-bottom:9px;">Will It Fit Your Vehicle?</div>' +
          '<div style="display:flex;gap:7px;">' +
          '<select id="ffb-year" style="flex:1;min-width:0;height:41px;font-size:13.5px;padding:0 6px;border-radius:6px;border:1px solid #d1d5db;background:#fff;color:#111827;"><option value="">Year</option></select>' +
          '<select id="ffb-make" style="flex:1;min-width:0;height:41px;font-size:13.5px;padding:0 6px;border-radius:6px;border:1px solid #d1d5db;background:#fff;color:#111827;" disabled><option value="">Make</option></select>' +
          '<select id="ffb-model" style="flex:1;min-width:0;height:41px;font-size:13.5px;padding:0 6px;border-radius:6px;border:1px solid #d1d5db;background:#fff;color:#111827;" disabled><option value="">Model</option></select>' +
          '</div><div id="ffb-verdict" style="margin-top:8px;"></div>';
        form.parentNode.insertBefore(box, form);
      }
      var yr = box.querySelector("#ffb-year"), mk = box.querySelector("#ffb-make"),
          md = box.querySelector("#ffb-model"), vd = box.querySelector("#ffb-verdict");
      if (!yr || !mk || !md || !vd) throw new Error("fit selector DOM is incomplete");
      var years = {};
      V.forEach(function (v) {
        var start = Number(v.year_start), end = Number(v.year_end);
        if (!Number.isFinite(start) || !Number.isFinite(end)) return;
        for (var y = start; y <= end; y++) years[y] = true;
      });
      yr.length = 1;
      mk.length = 1;
      md.length = 1;
      mk.disabled = true;
      md.disabled = true;
      vd.innerHTML = "";
      Object.keys(years).sort(function (a, b) { return Number(b) - Number(a); })
        .forEach(function (y) { yr.add(new Option(y, y)); });
      function inYear(v) {
        var y = Number(yr.value);
        return y >= Number(v.year_start) && y <= Number(v.year_end);
      }
      function fillMakes() {
        mk.length = 1; md.length = 1; md.disabled = true; vd.innerHTML = "";
        var seen = {};
        V.filter(inYear).forEach(function (v) { seen[v.make] = true; });
        Object.keys(seen).sort().forEach(function (m) { mk.add(new Option(m, m)); });
        mk.disabled = !yr.value || mk.length === 1;
      }
      function fillModels() {
        md.length = 1; vd.innerHTML = "";
        var seen = {};
        V.filter(function (v) { return inYear(v) && v.make === mk.value; })
          .forEach(function (v) { seen[v.model] = true; });
        Object.keys(seen).sort().forEach(function (m) { md.add(new Option(m, m)); });
        md.disabled = !mk.value || md.length === 1;
      }
      function verdict() {
        var v = V.filter(function (x) {
          return inYear(x) && x.make === mk.value && x.model === md.value;
        })[0];
        if (!v || !yr.value) return;
        var info = VD[v.category] || {};
        var ok = (info.seat_cover_verdict === "fits_well" || info.seat_cover_verdict === "fits_with_notes");
        var car = yr.value + " " + mk.value + " " + md.value;
        if (ok) {
          vd.innerHTML = '<div style="font-size:13.5px;font-weight:600;color:#166534;">✓ Compatible with your ' + car + '</div>' +
            '<div style="font-size:12px;color:#6B7280;margin-top:3px;">Fit may vary by seat shape and configuration.</div>';
        } else {
          vd.innerHTML = '<div style="font-size:13.5px;font-weight:600;color:#B45309;">Not compatible with universal covers</div>' +
            '<div style="font-size:12px;color:#6B7280;margin-top:3px;"><a href="/collections/custom-fit" style="color:#1d4ed8;">See our Custom Fit series →</a></div>';
        }
        try { localStorage.setItem("fonesoGarage", JSON.stringify({make: mk.value, model: md.value, year: yr.value, cat: v.category})); } catch (e) {}
      }
      yr.onchange = fillMakes; mk.onchange = fillModels; md.onchange = verdict;
      try {
        var g = JSON.parse(localStorage.getItem("fonesoGarage") || "null");
        if (g && years[g.year]) {
          yr.value = g.year; fillMakes(); mk.value = g.make; fillModels(); md.value = g.model; verdict();
        }
      } catch (e) {}
    }).catch(function (error) {
      disableDependentSelects();
      console.error("[Foneso Fit] Failed to load vehicle data:", error);
    });
  }
})();
